<ng-container [formGroup]="form">
  <mat-form-field>
    <mat-label>Sort By</mat-label>
    <input
      autocomplete="off"
      type="text"
      formControlName="value"
      id="extensionSortBy"
      lcsStaticSelect
      [lcsSingleSelect]="extensionSortBySelect"
      [lcsStaticSelectValue]="form.get('value')?.value"
      [required]="true"
      />
      <lcs-static-select #extensionSortBySelect [displayWith]="extensionSortByDisplayWith">
        @for (extensionSortBy of extensionSortBy; track extensionSortBy) {
          <lcs-option [value]="extensionSortBy">
            {{ extensionSortBy }}
          </lcs-option>
        }
      </lcs-static-select>
    </mat-form-field>
  </ng-container>
